import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { GET_SEO_DATA } from '@graphql/article/article.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import { GET_CATEGORY_NEWS_VIDEOS } from '@graphql/series/home.query'
import { HotStories } from '@shared/components/F1Components/EditorsPick'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

import DriverDetail from '@shared/components/driverDetail'
import queryGraphql from '@shared/components/queryGraphql'
import Layout from '@shared/components/layout'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function DriverPage({ driverData, news, seo }) {
  const data = news?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults?.slice(0, 3) || []
  const { addTop, mobSm, addBottom, addLeft } = reviveAdData
  return (
    <Layout data={{ oSeo: seo?.getSeoData }}>
      <div className="container pb-5">
        <div className="w-full d-none d-xl-flex justify-content-center my-3">
          <ReviveAds {...addTop} className={'my-3'} />
        </div>
        <div className="w-full d-flex d-xl-none justify-content-center my-1">
          <ReviveAds {...mobSm} className={'my-1'} />
        </div>
        <DriverDetail driverData={driverData} />
        <HotStories news={data} />
        <div className="w-full d-flex d-xl-none justify-content-center my-2">
          <ReviveAds {...addLeft} className={'my-2'} />
        </div>
        <div className="w-full d-none d-xl-flex justify-content-center my-3">
          <ReviveAds {...addBottom} className={'my-3 text-center'} />
        </div>
      </div>
    </Layout>
  )
}

DriverPage.propTypes = {
  driverData: PropTypes.object,
  news: PropTypes.object,
  seo: PropTypes.object
}

export default DriverPage

export async function getServerSideProps({ res, resolvedUrl, params }) {
  const { slug } = params
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')

    const BASE_URL = GRAPHQL_URL.replace(/\/graphql$/, '')

    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: `formula1-racing/drivers/${slug?.[0]}` } })

    const urlDriverDetails = new URL(`${BASE_URL}/api/global-widget/f1/get/driver-details/${seo?.getSeoData?.iId}`)

    const driverDetailResponse = await fetch(urlDriverDetails, {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    })
    const driversDetailData = await driverDetailResponse.json()

    const [news] = await parallelCalls([
      queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
        input: {
          nLimit: 5,
          nSkip: 0,
          iCategoryId: '66226bd0c8717f761bf48525',
          eType: 'vn'
        }
      })
    ])
    return {
      props: {
        driverData: driversDetailData || {},
        news: news || {},
        seo: seo || {}
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
